module.exports = __webpack_public_path__ + "0d04b22c7116df2ba45828c3b3cc408e.png";